import { IIconBase } from '..'

const accessoryIcon = ({
  color = '#333752',
  height = 16,
  width = 17,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.5 4.66683V11.3335C14.5 13.3335 13.5 14.6668 11.1667 14.6668H5.83333C3.5 14.6668 2.5 13.3335 2.5 11.3335V4.66683C2.5 2.66683 3.5 1.3335 5.83333 1.3335H11.1667C13.5 1.3335 14.5 2.66683 14.5 4.66683Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8334 1.3335V6.57349C10.8334 6.86682 10.4867 7.01348 10.2734 6.82015L8.72677 5.39351C8.6001 5.27351 8.40006 5.27351 8.2734 5.39351L6.72677 6.82015C6.51343 7.01348 6.16675 6.86682 6.16675 6.57349V1.3335H10.8334Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.33325 9.3335H12.1666'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.5 12H12.1667'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default accessoryIcon
